import { ChevronLeft, ChevronRight } from "lucide-react";

export const StripArrow = ({ dir, onClick, testId, className = "", label }) => (
  <button
    type="button"
    aria-label={label || (dir < 0 ? "Previous" : "Next")}
    onClick={onClick}
    data-testid={testId}
    className={`absolute top-1/2 -translate-y-1/2 z-10 w-8 h-8 rounded-full bg-[#1B2A41] text-[#FDFBF7] border border-[#E2705A]/70 shadow-md flex items-center justify-center hover:bg-[#E2705A] transition-colors ${className}`}
  >
    {dir < 0 ? <ChevronLeft className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
  </button>
);

export const scrollStrip = (ref, d) =>
  ref.current?.scrollBy({ left: d * Math.round(ref.current.clientWidth * 0.8), behavior: "smooth" });
